<template>
  <v-form>
    <v-row dense>
      <v-col cols="12" md="4" xs="12" sm="12">
        <v-text-field dense outlined label="Category Name" v-model="record.Name"></v-text-field>
      </v-col>

      <v-col cols="12" md="12" xs="12" sm="12">
        <v-btn color="accent" @click="sendData" :loading="$store.state.btnLoader">
          <v-icon left>mdi-content-save</v-icon>Save
        </v-btn>
      </v-col>

      <snackbar ref="snackbar"></snackbar>
    </v-row>
  </v-form>
</template>


<script>
export default {
  name: "AccountsIndex",
  props: {
    initial: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    record: {},
    loader: false,
    date: new Date().toISOString().substr(0, 10),
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true,
    },
  },
  methods: {
    init(val) {
      this.record = { ...val };
    },
    setDate(date) {
      this.record.date = date;
    },
    sendData() {
      if (this.record.Name == null || this.record.Name == undefined) {
        this.$refs.snackbar.show("Please fill category name", "red");
      } else {
        this.$store.commit("btnLoader", true);
        this.$emit("data", this.record);
      }
    },
  },
};
</script>